import { createSlice } from "@reduxjs/toolkit";
import { getWeekDays } from "./weekDaysThunk";

const initialState = {
  data: null,
  loading: false,
  error: null,
  success: null,
  errorMessage: "",
};

export const weekDaysSlice = createSlice({
  name: "content",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWeekDays.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getWeekDays.fulfilled, (state, action) => {
      state.loading = false;
      state.error = false;
      state.success = true;
      state.data = action.payload;
    });
    builder.addCase(getWeekDays.rejected, (state, action) => {
      state.loading = false;
      state.error = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default weekDaysSlice.reducer;
